import config from "./ConfigClass";
import sdws from "./SDWebservice.js"
import {transferStore} from './TasksStore';
import promptClass from "./prompt.js"
import {serverurl} from "./FirstConfig.svelte";



class PostMessageAdapter {
    unsubscribe;
    open=true;
    firstconfigelement;

    constructor() {}

    async postMessage(data){
        let result;

        if (data.key==="init") {
            // get server
            let initwidth = 512;
            let initheight = 512;
            let initurl = "";
            let initbearer=""
            let Config=new config()
            await Config.load()
            await Config.get()
            console.log("config");
            this.firstconfigelement = document.createElement('fds-first-config') ;
            this.firstconfigelement.serverurl = Config.generalConfig.url || window.location.href;
            this.firstconfigelement.bearer = Config.generalConfig.token;

            document.body.appendChild(this.firstconfigelement);
            if (!Config.configList.length) {
                this.firstconfigelement.open  = true;
            }
            this.firstconfigelement.open  = true;
            while (this.firstconfigelement.open) {
                await new Promise(r => setTimeout(r, 500));
            }
            initurl = this.firstconfigelement.serverurl || initurl;
            initwidth = this.firstconfigelement.initwidth || initwidth;
            initheight = this.firstconfigelement.initheight || initheight ;
            initbearer = this.firstconfigelement.bearer

            if (!Config.configList.length) {
                await Config.add('SDGRPC');
            }
            Config.generalConfig.url = initurl;
            Config.generalConfig.token = initbearer;
            await Config.set();
            //}

            var canvas = document.createElement("canvas");
            // set desired size of transparent image
            canvas.width = initwidth;
            canvas.height = initheight;
            let base64 =canvas.toDataURL().split(';base64,')[1];

            let WS=new sdws()
            let server_features=await WS.getServerFeatures(Config.generalConfig)
            console.log("server_features",server_features);

             result = {
                 data:
                     {
                         base64,
                         key: "init",
                         documentInfo: {width: initwidth, height: initheight},
                         Config,
                         num: Config.currentConfigNum,
                         serverFeatures: server_features
                     }
             }
        }

        if (data.key==="changeModel") {
            result = await this.changeConfigElement({objkey:'model',value:data.model});
        }

        if (data.key==="changeInpaintingModel") {
            result = await this.changeConfigElement({objkey:'inpainting_model',value:data.model});
        }

        if (data.key==="changeGeneralConfig") {
            result = await this.changeConfigElement({objkey:data.type,value:data.value});
        }


        if (data.key==="changeGlobalData") {
            let Config=new config()
            Config.updateGlobalData(data.globalData)
        }



        if (data.key==="changeSize") {
            let objkey;
            if (data.type==="width") {
                objkey = "width"

            }
            if (data.type==="height") {
                objkey = "height"
            }
            result = await this.changeConfigElement({objkey,value:data.value});
        }

        if (data.key==="numberImages") {

                let Config=new config()
                await Config.load()
                await Config.get()
                Config.generalConfig.dlgData.num=parseInt(data.num)
                Config.set()
        }

        if (data.key==="modifierSave") {
            let Config=new config()
            await Config.load()
            await Config.get();
            Config.ModifierData = JSON.parse(data.modifier.modifierdata);
            await Config.save();
        }


        if (data.key==="changeSampler") {
               let Config=new config()
                await Config.load()
                await Config.get()
                Config.generalConfig.dlgData.sampling_method=data.sampling_method
                Config.set()
        }


        if ( data.key==="cancelRequest") {
            let WS=new sdws()
            await WS.cancelRequest(data.Config.generalConfig,data.taskid);
        }

        if ( data.key==="generate") {

            let layer=data.layer
            let p=new promptClass(layer.taskid)
            // @ts-ignore
            let prompt=await p.getPromptObject(layer.generate,layer.generate.mode,layer.ImageInfo,layer.AlphaImageInfo,layer.DepthImageInfo,layer.specialLayersImageInfo)
            let WS=new sdws()
            let images=await WS.runSD(data.Config.generalConfig,prompt);


            if (!this.unsubscribe) {
                this.unsubscribe = transferStore.subscribe(async (taskel) => {
                    if (!taskel) return;
                    if (!taskel.taskid) return;
                    let res = taskel.answers.answer.map((el)=>{
                        let im = el.artifacts[0];
                        //let base64 = "data:image/png;base64,"+im.binary;
                        let base64 = im.binary;
                        let seed = im.seed;
                        let  complete = taskel.answers.complete;
                        let retobj = {base64,seed};
                        if (complete) retobj.complete = true;
                        return retobj;
                    })

                    window.postMessage({
                                key: "generateBack",
                                taskid: taskel.taskid,
                                imagelist: res,
                                generateasync: !window.generatesync
                    });

                    transferStore.set();
                });
            }


            result = {
                data:
                    {
                        key: "generateBack",
                        taskid: layer.taskid,
                        generateasync: !window.generatesync,
                        imagelist: images
                    }
            };


        }

   if(result) window.postMessage(result.data);
    }


    async changeConfigElement(element){
        let Config=new config()
        await Config.load()
        await Config.get()
        Config.generalConfig[element.objkey]=element.value;
        await Config.set()

        let WS=new sdws()
        let server_features=await WS.getServerFeatures(Config.generalConfig)
        console.log("server_features",server_features);

        let response = {
            data:
                {
                    key: "switchConfig",
                    num: Config.currentConfigNum,
                    serverFeatures: server_features
                }
        }
        return response;
    }


}
let inst = new PostMessageAdapter();
window.postMessageAdapter  = inst;
export default inst;
